import React, { FC } from 'react'
import { StyledIcon, StyledIconProps } from '.'

export const CsFilterIcon: FC<StyledIconProps> = (props) => (
  <StyledIcon viewBox="0 0 1024 1024" {...props}>
    <g>
      <path d="M801.714 177.714q9.714 23.429-8 40L512 499.428v424q0 24-22.286 33.714-7.429 2.857-14.286 2.857-15.429 0-25.714-10.857L303.428 802.856q-10.857-10.857-10.857-25.714V499.428L10.857 217.714q-17.714-16.571-8-40 9.714-22.286 33.714-22.286H768q24 0 33.714 22.286z" />
    </g>
  </StyledIcon>
)

CsFilterIcon.displayName = 'CsFilterIcon'
